import styled from '@emotion/styled';

export const Wrapper = styled.div`
  padding: 0.5em 0;
  cursor: pointer;
`;

export const Container = styled.div`
  display: flex;
  background-color: rgba(255, 255, 255, 0.2);
  height: 0.25em;
  width: 100%;
  position: relative;

  &:focus-visible {
    outline: none;
    box-shadow: inset 0 0 0 1px #63b3ed, 0 0 3px 1px #63b3ed;
  }
`;

interface ProgressProps {
  progress: number;
  color: string;
}

export const Progress = styled.div<ProgressProps>`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  background: ${({color}) => color};
  width: 100%;
  transform: scale(${({progress}) => progress}%, 100%);
  transform-origin: left;
  transition: transform 100ms linear;
  pointer-events: none;
`;

interface HandleProps {
  position: string;
  visible: boolean;
}
export const Handle = styled.div<HandleProps>``;
